import React, { useState } from "react";
import { useAppStateContext } from "src/auth/AppStateContext";
import APIService from "src/services/Api";
import useQueryListAdminNotification from "src/hooks/useQueryListAdminNotification";
import { IoIosNotificationsOutline } from "react-icons/io";
import ImgBellNotificationAdmin from "src/assets/images/bellnotification.gif";

type ParamNavAdmin = {
  handleShowNav:(value:boolean) => void
}


const NavUserAdminNotification: React.FC<ParamNavAdmin> = ({handleShowNav}) => {
  const { notificationAdminList } = useQueryListAdminNotification(0);
  const [alert, setAlert] = useState<boolean>(true)
  const { adminNotifications } = useAppStateContext();
    const viewNotifications = async() => {
      setAlert(false)
      handleShowNav(true)
      if(adminNotifications.some(n => !n.seen)){
        await APIService.systemViewNotifications({type:'admin'})
      }
    }
    React.useEffect(() => {
        setAlert(true)
    }, [adminNotifications, notificationAdminList])
    
  return (
    <div>
      {adminNotifications && adminNotifications.length > 0 && (
        <div className="relative rounded-full px-2 py-1 hover:bg-gray-300 cursor-pointer transition duration-500 ease-in-out transform hover:-translate-y-0  ">
  {/*         {adminNotifications.length === 0 && (
            <div>
              <IoIosNotificationsOutline className="text-stone-300" size={30} />
            </div>
          )}
 */}

            <div
              onClick={() => viewNotifications()}
              className="rounded-full"
            >
              {(adminNotifications.some(n => !n.seen) && alert) ? 
              <>
                <span className="notification-quantity border border-gray-100">
                {adminNotifications.filter((n) => !n.seen).length || 0} 
              </span>
                <img src={ImgBellNotificationAdmin} 
                  className="w-10"
                  alt="notificaciones" 
                />
                </>
              :
              <IoIosNotificationsOutline className="text-red-400" size={27} />
              }
            </div>
          
        </div>
      )}
    </div>
  );
};

export default NavUserAdminNotification;
